<template>
  <div class="">

    <template v-if="isBar" >
      <!-- header start -->
      <van-nav-bar 
        title="孝爱网隐私政策" 
        left-arrow 
        fixed 
        :z-index="99" 
        @click-left="onClickLeft" 
        :border="false"
      />
      <div class="navBarSpace"></div>
      <!-- header end -->
    </template>
  
    <div class="padding">
      <div v-if="html" v-html="html" ></div>
      <!-- <div class="title">孝爱网隐私政策</div>
      <div class="details">
        <h2>一、引言</h2>
        <P>孝爱网严格遵守法律法规，遵循以下隐私保护原则，为您提供更加安全、可靠的服务：</P>
        <P>•	一、安全可靠：</P>
        <P>我们竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失。</P>
        <P>•	二、自主选择：</P>
        <P>我们为您提供便利的信息管理选项，以便您做出合适的选择，管理您的个人信息。</P>
        <P>•	三、保护通信秘密：</P>
        <P>我们严格遵照法律法规，保护您的通信秘密，为您提供安全的通信服务。</P>
        <P>•	四、合理必要：</P>
        <P>为了向您和其他用户提供更好的服务，我们仅收集必要的信息。</P>
        <P>•	五、清晰透明：</P>
        <P>我们努力使用简明易懂的表述，向您介绍隐私政策，以便您清晰地了解我们的信息处理方式。</P>
        <P>•	六、将隐私保护融入产品设计：</P>
        <P>我们在产品或服务开发的各个环节，综合法律、产品、设计等多方因素，融入隐私保护的理念。</P>
        <P>本《隐私政策》主要向您说明：</P>
        <P>•	一、我们收集哪些信息</P>
        <P>•	二、我们收集信息的用途</P>
        <P>•	三、您所享有的权利</P>
        <P>希望您仔细阅读《隐私政策》（以下简称"本政策"），详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并作出适当的选择。</P>
        <P>若您使用孝爱网服务，即表示您认同我们在本政策中所述内容。</P>
        <h2>二、我们收集的信息</h2>
        <P>我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。</P>
        <P>一、您在使用我们服务时主动提供的信息</P>
        <P>•	1、您在使用我们服务时主动提供的信息</P>
        <P>例如，您在注册孝爱网帐户时所填写的昵称、手机号码。</P>
        <P>•	2、您在使用服务时上传的信息</P>
        <P>例如，您在使用孝爱网产品时，上传的头像、分享的照片。</P>
        <P>•	3、您通过我们的客服或参加我们举办的活动时所提交的信息</P>
        <P>例如，您参与我们线上活动时填写的调查问卷中可能包含您的姓名、电话、家庭地址等信息。我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。</P>
        <P>•	4、若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。</P>
        <P>二、我们在您使用服务时获取的信息</P>
        <P>•	1、日志信息</P>
        <P>当您使用我们的服务时，我们可能会自动收集相关信息并存储为服务日志信息。</P>
        <P>•	2、设备信息</P>
        <P>例如，设备型号、操作系统版本、唯一设备标识符、电池、信号强度等信息。</P>
        <P>•	3、IP地址</P>
        <P>•	4、服务日志信息</P>
        <P>例如，您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。</P>
        <P>•	5、通讯日志信息</P>
        <P>例如，您在使用我们服务时曾经通讯的账户、通讯时间和时长。</P>
        <P>•	6、位置信息</P>
        <P>当您使用与位置有关的服务时，我们可能会记录您设备所在的位置信息，以便为您提供相关服务。</P>
        <P>在您使用服务时，我们可能会通过IP地址 、GPS、WiFi或基站等途径获取您的地理位置信息；</P>
        <P>您或其他用户在使用服务时提供的信息中可能包含您所在地理位置信息；</P>
        <P>例如您提供的帐号信息中可能包含的您所在地区信息，您或其他人共享的照片包含的地理标记信息；</P>
        <P>•	7、其他相关信息</P>
        <P>为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。例如，我们收集的好友列表、群列表信息、声纹特征值信息。为确保您使用我们服务时能与您认识的人进行联系，如您选择开启导入通讯录功能，我们可能对您联系人的姓名和电话号码进行加密，并仅收集加密后的信息。</P>
        <P>三、其他用户分享的信息中含有您的信息</P>
        <P>•	例如，其他用户发布的照片或分享的视频中可能包含您的信息。</P>
        <P>四、从第三方合作伙伴获取的信息</P>
        <P>•	我们可能会获得您在使用第三方合作伙伴服务时所产生或分享的信息。您仔细阅读第三方合作伙伴服务的用户协议或隐私政策。</P>
        <h2>三、我们如何使用收集的信息</h2>
        <P>我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下途使用您的信息，我们将再次向您进行说明，并征得您的同意。</P>
        <P>•	一、向您提供服务</P>
        <P>•	二、满足您的个性化需求</P>
        <P>例如，语言设定、位置设定、个性化的帮助服务。</P>
        <P>•	三、产品开发和服务优化</P>
        <P>例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。</P>
        <P>•	四、安全保障</P>
        <P>例如，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。</P>
        <P>•	五、向您推荐您可能感兴趣的广告、资讯等</P>
        <P>•	六、评估、改善我们的广告投放和其他促销及推广活动的效果</P>
        <P>•	七、管理软件</P>
        <P>例如，进行软件认证、软件升级等。</P>
        <P>•	八、邀请您参与有关我们服务的调查</P>
        <P>为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告、用于用户研究分析与统计等服务。</P>
        <P>为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，您使用应用程序的频率、故障信息、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。</P>
        <h2>四、您分享的信息</h2>
        <P>您可以通过我们的服务与您的好友、家人及其他用户分享您的相关信息。例如，您在姓氏部落公开分享的文字和照片。</P>
        <P>请注意，这其中可能包含您的个人身份信息、个人财产信息等敏感信息。</P>
        <P>请您谨慎考虑披露您的相关个人敏感信息。</P>
        <P>您可通过我们服务中的隐私设置来控制您分享信息的范围，也可通过服务中的设置或我们提供的指引删除</P>
        <P>您公开分享的信息。但请您注意，这些信息仍可能由其他用户或不受我们控制的非关联第三方独立地保存。</P>
        <h2>五、您如何管理自己的信息</h2>
        <P>•	您可以在使用我们服务的过程中，访问、修改和删除您提供的注册信息和其他个人信息，也可按照通知指引与我们联系。</P>
        <P>•	您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。</P>
        <P>例如，若您在使用地理位置相关服务时，希望停止分享您的地理位置信息，您可通过手机定位关闭功能、软硬件服务商及通讯服务提供商的关闭方式停止分享，建议您仔细阅读相关指引。</P>
        <P>•	我们将按照本政策所述，仅为实现我们产品或服务的功能，收集、使用您的信息。</P>
        <P>如您发现我们违反法律、行政法规的规定或者双方的约定收集、使用您的个人信息，您可以要求我们删除。</P>
        <P>如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。</P>
        <P>请通过本政策列明的联系方式与我们联系。</P>
        <P>在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。</P>
        <h2>六、我们如何使用cookie及相关技术</h2>
        <P>我们或我们的第三方合作伙伴，可能通过放置安全的Cookie及相关技术收集您的信息，目的是为您提供更个性化的用户体验和服务。</P>
        <P>我们会严格要求第三方合作伙伴遵守本政策的相关规定。</P>
        <P>•	您也可以通过浏览器设置管理Cookie。但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</P>
        <h2>七、我们分享的信息</h2>
        <P>我们遵照法律法规的规定，以下情况我们可能会向第三方分享您的个人信息：</P>
        <P>•	一、为了向您提供服务，我们可能会与第三方合作伙伴、服务供应商、承包商、代理商、广告合作伙伴等分享您的个人信息，让他们按照我们的说明、隐私政策或其他相关的保密和安全措施来为我们处理上述信息，并用于以下用途：</P>
        <P>•	</P>
        <P>o	1、向您提供我们的服务；</P>
        <P>o	2、实现"我们如何使用收集的信息"部分所述目的；</P>
        <P>o	3、履行我们在本政策中的义务和行使我们的权利；</P>
        <P>o	4、理解、维护和改善我们的服务。</P>
        <P>•	二、随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向第三方分享您的个人信息时，我们将通过推送通知、公告等形式告知您相关情形，按照法律法规及不低于本政策所要求的标准继续保护或要求新的管理者继续保护您的个人信息。</P>
        <P>•	三、我们会将所收集到的信息用于大数据分析。</P>
        <P>例如，我们将收集到的信息用于分析形成不包含任何个人信息的城市热力图或行业洞察报告。</P>
        <P>四、我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。</P>
        <P>•	五、我们可能基于以下目的披露您的个人信息</P>
        <P>o	1、遵守适用的法律法规等有关规定；</P>
        <P>o	2、遵守法院判决、裁定或其他法律程序的规定；</P>
        <P>o	3、遵守相关政府机关或其他法定授权组织的要求；</P>
        <P>o	4、我们有理由确信需要遵守法律法规等有关规定；</P>
        <P>o	5、为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、</P>
        <P>o	6、其他用户或雇员的人身财产安全或其他合法权益合理且必要的用途。</P>
        <h2>八、我们可能向您发送的信息</h2>
        <P>信息推送</P>
        <P>您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知。</P>
        <P>您可以按照我们的相关提示，在设备上选择关闭推送。</P>
        <P>与服务有关的公告</P>
        <P>我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。</P>
        <P>您可能无法取消这些与服务有关、性质不属于广告的公告。</P>
        <h2>九、存储信息的地点和期限</h2>
        <P>存储信息的地点</P>
        <P>我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。</P>
        <P>存储信息的期限</P>
        <P>一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有能因需符合法律要求，更改个人信息的存储时间</P>
        <P>•	1、为遵守适用的法律法规等有关规定；</P>
        <P>•	2、为遵守法院判决、裁定或其他法律程序的规定；</P>
        <P>•	3、为遵守相关政府机关或法定授权组织的要求；</P>
        <P>•	4、我们有理由确信需要遵守法律法规等有关规定；</P>
        <P>•	5、为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。</P>
        <P>•	6、当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。</P>
        <h2>十、信息安全</h2>
        <P>我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露。</P>
        <P>•	我们严格遵守法律法规保护用户的通信秘密。</P>
        <P>•	我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。</P>
        <P>•	我们建立专门的管理制度、流程和组织确保信息安全。</P>
        <P>•	若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。</P>
        <h2>十一、未成年人保护</h2>
        <P>我们非常重视对未成年人个人信息的保护。</P>
        <P>•	根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用孝爱网的服务前，应事先取得您的家长或法定监护人的同意。</P>
        <P>•	若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过第十三部分中的联系方式与我们联系。</P>
        <h2>十二、适用范围</h2>
        <P>我们的所有服务均适用本政策。</P>
        <P>•	某些服务有其特定的隐私指引/声明，该特定隐私指引/声明更具体地说明我们在该服务中如何处理您的信息。</P>
        <P>•	如本政策与特定服务的隐私指引/声明有不一致之处，请以该特定隐私指引声明为准。</P>
        <P>•	请您注意，本政策不适用由其他公司或个人提供的服务。</P>
        <P>•	您使用该等第三方服务须受其隐私政策（而非本政策）约束，您需要仔细阅读其政策内容。</P>
        <h2>十三、联系我们</h2>
        <P>如您对本政策或其他相关事宜有疑问，</P>
        <P>将您的问题发送至 TT@waheaven.com</P>
        <P>我们将尽快审核所涉问题，并在验证您的用户身份后的三十天内予以回复。</P>
        <h2>十四、变更</h2>
        <P>我们可能适时修订本政策内容。</P>
        <P>•	如该等变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。</P>
        <P>•	在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。</P>
        <h2>十五、名词解释</h2>
        <P>•	个人信息</P>
        <P>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，包括但不限于自然人的姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码等。</P>
        <P>•	个人敏感信息</P>
        <P>个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。例如，个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息等。</P>
        <P>•	设备</P>
        <P>设备是指可用于访问孝爱网服务的装置，例如台式计算机、笔记本电脑、平板电脑或智能手机。</P>
        <P>•	唯一设备标识符</P>
        <P>唯一设备标识符（专属 ID 或 UUID）是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（例如手机的 IMEI 号）。唯一设备标识符有多种用途，其中可在不能使用cookies（例如在移动应用程序中）时用以提供广告。</P>
        <P>•	IP地址</P>
        <P>每台上网的设备都会指定一个编号，称为互联网协议 (IP) 地址。这些编号通常都是根据地理区域指定的。IP 地址通常可用于识别设备连接至互联网时所在的位置。</P>
        <P>•	GPS</P>
        <P>Global Positioning System（全球定位系统）的简称。您使用的设备上的GPS信号接收器可以从GPS卫星收到信号并利用传来的信息计算您的位置。</P>
        <P>•	WIFI</P>
        <P>Wi-Fi是一种允许电子设备连接到一个无线局域网（WLAN）的技术，通常我们所说的无线网络。</P>
        <P>信息收集技术</P>
        <P>我们在《隐私政策》中所述的"自动收集"包括以下方式：</P>
        <P>•	1、Cookie（曲奇档案）</P>
        <P>Cookie是您浏览网页时，网站服务器放在客户端（您的计算机、移动电话或其他智能终端内）里面的一个小小的文本文件，可用于改善您的使用体验，具体可参见《Cookie政策说明》。</P>
        <P>•	2、Web beacon（网络信标）</P>
        <P>Web beacon是装嵌在网站或电邮内的电子图像文件案或其他技术，可用于计算访客数目、记录您是否及何时阅览电邮或网站，或用以使用某些Cookie。</P>
        <P>•	3、Log files（日志文件）</P>
        <P>Log files储存自动收集的若干数据。该等数据包括互联网协议（IP）地址、浏览器类型、互联网服务提供商（ISP）、引用/退出页面、操作系统、日期/时间戳和点击流数据等。</P>
        <P>•	4、ET Tag（实体标签）</P>
        <P>ET Tag是在互联网浏览器与互联网服务器之间背后传送的HTTP协议标头，可代替Cookie，用以追踪个别使用者，使我们可更深入地了解和改善我们的服务。</P>
        <P>•	5、JavaScript</P>
        <P>JavaScript是一种编程语言，用于制作更具互动性和动态的网页。JavaScript可以设定Cookie、阅读Cookie及删除Cookie。</P>

      </div> -->
    </div>

  </div>
</template>

<script>
	export default {
	  data() {
	    return {
        keyName:"隐私政策",
        html:null,
        isBar:true
	    };
	  },
	  components: {
    },
    
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
      },
      init(){
        var that = this;
        this.$store.dispatch({
          type:"HtmlInfoGetHtmlInfoByKeyName",
          KeyName : that.keyName,
        }).then(res => {
          that.html = res;
        }, err => {})
      }
    },
    created(){
      var _isBar=this.$route.query.Isbar;
      if(_isBar)
      {
          this.isBar=false;
      }

      this.init();
    }
	};
</script>

<style scoped>
.padding{
  padding: 15px 10px;;
}
.padding .title{
  font-weight: normal;
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
}
.details h2{
  font-size: 16px;
  font-weight: bold;
  margin-top: 18px;
  margin-bottom: 6px;
}
.details p{
  font-size: 14px;
  margin-bottom: 6px;
  line-height: 1.5;
}
</style>
